import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  Container,
  Badge,
  ButtonGroup,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import moment from 'moment'

// Databale

import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Toast } from "primereact/toast";
import "primeicons/primeicons.css";

import "../../asset/style.css";

import { APIKEY } from "../../Config/Config";
const API_View = `${APIKEY}/Company_image`;
const API_Company = `${APIKEY}/Company`;

class ResourceDownloadList extends Component {
  constructor() {
    super();
    this.editor = React.createRef();
    this.state = {  
        Resourcedownloadlistdata: [],
      showAdd:false,
    //   modal
      show: false,
      Reportmodal: false,
      fullscreen: true,
      Deletemodal: "",
      Statusmodal: "",
      // datatable
      filters1: null,
      globalFilterValue1: "",
      loading1: true,
      balanceFrozen: true,
    };
    this.onGlobalFilterChange1 = this.onGlobalFilterChange1.bind(this);
    this.BlogStatus = this.BlogStatus.bind(this);
    this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    this.rightToolbarTemplate = this.rightToolbarTemplate.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this. onChangeJobs = this. onChangeJobs.bind(this);
  }

  componentDidMount() {
    this.getAll();
   
    this.initFilters1();
  }

  getAll() { 
   
    axios.get(`${APIKEY}/Resources/download/list`).then((res) => {
        const Result = res.data;
        this.setState({
            Resourcedownloadlistdata: Result,
                loading1: false,
              });
      
        
    console.log("rrrr",Result)
    });
  }
  
  // Datatable Start
  onGlobalFilterChange1(e) {
    const value = e.target.value;
    let filters1 = { ...this.state.filters1 };
    filters1["global"].value = value;

    this.setState({ filters1, globalFilterValue1: value });
  }
  initFilters1() {
    this.setState({
      filters1: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      globalFilterValue1: "",
    });
  }

  renderHeader1() {
    return (
      <div className="flex justify-content-between">
        {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearFilter1} /> */}
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={this.state.globalFilterValue1}
            onChange={this.onGlobalFilterChange1}
            placeholder="Keyword Search"
          />
        </span>
      </div>
    );
  }
 
  exportCSV() {
    this.dt.exportCSV();
  }

  leftToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={this.confirmDeleteSelected} disabled={!this.state.selectedProducts || !this.state.selectedProducts.length} /> */}
        <div>
          <h3> Resource download List</h3>
        </div>
      </React.Fragment>
    );
  }

  rightToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <FileUpload mode="basic" name="demo[]" auto url="https://primefaces.org/primereact/showcase/upload.php" accept=".csv" chooseLabel="Import" className="mr-2 inline-block" onUpload={this.importCSV} /> */}
        <Button
          label="Export"
          variant="warning"
          className=" bg-warning me-2 btn text-white"
          onClick={this.exportCSV}
        >
          Export
        </Button>
       
      </React.Fragment>
    );
  }
  // Datatable end
  BlogStatus(rowData) {
    return (
        <>
        <div className=''>
        {rowData.Created ? (
                                  <>
                                   <p>{moment(rowData.Created).format("YYYY-MM-DD")}</p>
                                  </>
                                ) :  null}
  
        </div>
         
        </>
    );
  }
  // Edit Click Button Start
  EditClickButton = (rowData) => {
    if (rowData) {
        console.log("kkk",rowData)
      this.setState({
        ID: rowData._id,
        CompanyValue:[],
      CompanyName: rowData.CompanyName,
      CompanyLogo: rowData.CompanyLogo,
      JobTitle: rowData.JobTitle,
      Department: rowData.Department,
      Location: rowData.Location,
      EmploymentType: rowData.EmploymentType,
      JobDate: rowData.JobDate,
      CompanyUrl: rowData.CompanyUrl,
        show: true,
      });
    }
  };
  // Edit Click Button End

  // Delete click button start
  DeleteClickButton = (id) => {
    if (id) {
      this.setState({
        ID: id,
        Deletemodal: true,
      });
    }
  };
  // Delete click button end

 
  // Delete click button end

  // Onchange
   onChangeJobs = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
    console.log("onchnage", value);
  };

  companyChange = async (event) => {
    this.setState({
        CompanyValue:event
    })
    
     axios.get(`${API_Company}/${event.value}`).then((res)=>{
        this.setState({
            CompanyName: res.data.CompanyName,
            CompanyLogo: res.data.CompanyLogo
        })
     })  
  }
 
 
 
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {}
  
   
  render() {
    const header1 = this.renderHeader1();

    return (
      <>
        <div className="container-fluid">
          <Toast ref={(el) => (this.toast = el)} />

        
          <div>
            {/* Datatable start*/}

            <Toolbar
              className="mb-4"
              left={this.leftToolbarTemplate}
              right={this.rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              value={this.state.Resourcedownloadlistdata}
              ref={(el) => (this.dt = el)}
              size="small"
              paginator
              scrollable
              scrollHeight="400px"
              className="p-datatable-customers"
              showGridlines
              rows={10}
              dataKey="id"
              filters={this.state.filters1}
              filterDisplay="menu"
              loading={this.state.loading1}
              responsiveLayout="scroll"
              globalFilterFields={["Name","CompanyName","Resource","CompanyEmail","Country"]}
              header={header1}
              emptyMessage="No Jobs found."
            >
              <Column
                field="Resource"
                header="Resource Name"
                alignFrozen="left"
                frozen={this.state.balanceFrozen}
                style={{ minWidth: "12rem" }}
              />
              <Column
                field="Name"
                header="Name"
                 
                style={{ minWidth: "250px " }}
              />

              <Column
                field="ContactNumber"
                header="Contact Number"
                style={{ minWidth: "300px" }}
              />

              <Column
                field="CompanyName"
                header="Company Name"
                style={{ minWidth: "300px" }}
              />
              <Column
                field="JobTitle"
                header="Job Title"
                style={{ minWidth: "300px" }}
              />
              <Column
                field="CompanyEmail"
                header="Company Email"
                style={{ minWidth: "300px" }}
              />
              <Column
                field="Country"
                header="Country"
                style={{ minWidth: "300px" }}
              />
              <Column
                field="Created"
                header="Resource Download Date"
                style={{ minWidth: "250px " }}
                body={this.BlogStatus}
              />
              </DataTable>
            {/* Datatable end*/}

          
          </div>
        </div>
      </>
    );
  }
}
export default ResourceDownloadList;
